import React, { Fragment } from "react";

// import Hero from "../components/Hero";
import ControlPanel from "../components/ControlPanel";

const Home = ({user}) => (
  <Fragment>
    <ControlPanel user={user} />
    <br />
    <br />
    <br />
    <br />
  </Fragment>
);

export default Home;
